<template>
  <div class="check-list-select">
    <div class="left">
      <ul>
        <li @click="activeChange(index)" v-for="(item, index) in selectData" :key="index" :class="active === index ? 'active' : ''">{{item.name}}</li>
      </ul>
    </div>
    <div class="right">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkAllData" @change="handleCheckedChange">
        <el-tooltip v-for="(item, index) in selectData[active].child" :key="index" :content="item.name" placement="bottom" effect="light">
          <el-checkbox :label="item.name">
            {{item.name}}
          </el-checkbox>
        </el-tooltip>
      </el-checkbox-group>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'checkListSelect',
    props: {
      allData: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        active: 0,
        selectData: [],
        isIndeterminate: false,
        checkAll: false,
        checkAllData: []
      }
    },
    created () {
      this.selectData = this.allData
    },
    methods: {
      handleCheckAllChange(val) {
        let allData = this.selectData[this.active].child.map((item) => {
          return item.name
        })
        this.checkAllData = val ? allData : []
        this.isIndeterminate = false
      },
      handleCheckedChange(value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.selectData[this.active].child.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.selectData[this.active].child.length
      },
      activeChange (index) {
        this.active = index
      },
      emptyCheckData () {
        this.active = 0
        this.checkAllData = []
        this.isIndeterminate = false
        this.checkAll = false
      }
    },
    computed: {
    },
    components: {
    },
    watch: {
      data () {
        this.selectData = this.allData
      }
    }
  }
</script>
<style lang="scss" scoped>
.check-list-select{
  width: 500px;
  height: 208px;
  border-radius: 2px;
  border: 1px solid rgba(204,204,204,.5);
  display: flex;
  .left{
    flex-shrink: 0;
    width: 104px;
    border-right: 1px solid rgba(204,204,204,.5);
    height: 100%;
    overflow: auto;
    padding: 0 1px 2px 2px;
    box-sizing: border-box;
    ul{
      margin: 0;
      padding: 0;
      li{
        margin: 0;
        list-style: none;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #333;
        margin-top: 2px;
        cursor: pointer;
      }
      li.active{
        background: rgba(5, 200, 175, .1);
        color:#05C8AF;
      }
    }
  }
  .right{
    flex-shrink: 0;
    padding: 21px 0 0 22px;
    width: 395px;
    box-sizing: border-box;
    overflow-y: auto;
    ::v-deep{
      .el-checkbox-group{
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        .el-checkbox{
          color: #333;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin: 0;
          margin-bottom: 20px;
          .el-checkbox__label{
            width: 90px;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>
